export default "__VITE_ASSET__BNIpyJUC__"